// import { Dispatch, SetStateAction, useState } from 'react';
import { Dispatch, SetStateAction, useState } from 'react';

import { DocumentType } from '@api/consumerloans-public-api';
import { useServicesStore } from '@store';

import { useDownloadPdf } from '../useDownloadPdf';

export interface CurrentPdf {
	type?: DocumentType | null;
	document?: string;
}

interface UsePdfViewerHookOutput {
	currentPdf?: CurrentPdf;
	isPdfOverlayVisible: boolean;
	setIsPdfOverlayVisible: Dispatch<SetStateAction<boolean>>;
	downloadPdf: (base64: string, documentName: string) => void;
}
/* eslint-disable sonarjs/cognitive-complexity */
export const usePdfViewer = (): UsePdfViewerHookOutput => {
	const { downloadPdf } = useDownloadPdf();
	const { currentPdf, saveServiceResponse } = useServicesStore();
	const [isPdfOverlayVisible, setIsPdfOverlayVisible] = useState(true);

	return {
		currentPdf,
		isPdfOverlayVisible,
		setIsPdfOverlayVisible,
		downloadPdf,
	};
};
